var render, staticRenderFns
import script from "./Pie-alocacaoTotal.vue?vue&type=script&lang=js&"
export * from "./Pie-alocacaoTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bc4412')) {
      api.createRecord('49bc4412', component.options)
    } else {
      api.reload('49bc4412', component.options)
    }
    
  }
}
component.options.__file = "src/views/pages/Rentabilidade/components/graficos/Pie-alocacaoTotal.vue"
export default component.exports